import * as tslib_1 from "tslib";
import { paginate } from '@core/utils/paginate';
import { Apollo } from 'apollo-angular';
import { sortBy } from 'lodash';
import { CompanyQueries } from './company.queries';
import * as i0 from "@angular/core";
import * as i1 from "apollo-angular";
import * as i2 from "./company.queries";
var CompanyService = /** @class */ (function () {
    function CompanyService(apollo, queries) {
        this.apollo = apollo;
        this.queries = queries;
    }
    CompanyService.prototype.listCompanies = function (_a) {
        var where = _a.where, options = _a.options;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var query, variables;
            return tslib_1.__generator(this, function (_b) {
                query = this.queries.listCompanies();
                variables = {
                    where: where,
                    orderBy: options.orderBy,
                    limit: options.limit,
                    offset: options.offset,
                };
                return [2 /*return*/, this.apollo.query({
                        query: query,
                        variables: variables
                    })
                        .toPromise()
                        .then(function (response) {
                        return {
                            items: response.data.companies.items,
                            totalCount: response.data.companies.totalCount,
                            filtered: Boolean(!!where.name_contains ||
                                where.archived !== false ||
                                !!where.field_account_id_contains)
                        };
                    })];
            });
        });
    };
    CompanyService.prototype.listAllMaintenanceTypes = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var query, maintenancesTypes;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = this.queries.listAllMaintenancesTypes();
                        return [4 /*yield*/, paginate({
                                apollo: this.apollo,
                                query: query,
                                perPage: 100,
                                itemsPropertyName: 'maintenanceTypes',
                            })];
                    case 1:
                        maintenancesTypes = _a.sent();
                        return [2 /*return*/, sortBy(maintenancesTypes, function (item) { return item.archived ? 1 : 0; })];
                }
            });
        });
    };
    CompanyService.prototype.getCompanyById = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var query, variables;
            return tslib_1.__generator(this, function (_a) {
                query = this.queries.getCompanyById();
                variables = { id: id };
                return [2 /*return*/, this.apollo
                        .query({ query: query, variables: variables })
                        .toPromise()
                        .then(function (response) { return response.data.company; })];
            });
        });
    };
    CompanyService.prototype.updateCompany = function (id, input) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var query, variables;
            return tslib_1.__generator(this, function (_a) {
                query = this.queries.updateCompany();
                variables = { id: id, input: input };
                return [2 /*return*/, this.apollo
                        .query({ query: query, variables: variables })
                        .toPromise()
                        .then(function (response) { return response.data.updateCompany; })];
            });
        });
    };
    CompanyService.prototype.archiveCompanyAndUnlinkServiceProvider = function (companyId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var query, variables;
            return tslib_1.__generator(this, function (_a) {
                query = this.queries.archiveCompanyAndUnlinkServiceProvider();
                variables = { companyId: companyId };
                return [2 /*return*/, this.apollo
                        .query({ query: query, variables: variables })
                        .toPromise()
                        .then(function (response) { return response.data.archiveCompanyAndUnlinkServiceProvider; })];
            });
        });
    };
    CompanyService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CompanyService_Factory() { return new CompanyService(i0.ɵɵinject(i1.Apollo), i0.ɵɵinject(i2.CompanyQueries)); }, token: CompanyService, providedIn: "root" });
    return CompanyService;
}());
export { CompanyService };
